module.exports = __webpack_public_path__ + "static/media/gpay.f17aed5c.svg";